import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import ObjectTypeDetail from './ObjectTypeDetail';
import * as objectTypeActions from './../../../../../actions/objectTypeAction';

const mapStateToProps = state => {
    return {
        objectTypeState: state.objectTypeReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getObjectTypeDetail: (id) => dispatch(objectTypeActions.getObjectTypeDetail(id)),
        setObjectTypeDetail: (objectType) => dispatch(objectTypeActions.setObjectTypeDetail(objectType)),
        updateObjectTypeDetail: (objectType) => dispatch(objectTypeActions.updateObjectTypeDetail(objectType)),
        createObjectTypeDetail: (objectType) => dispatch(objectTypeActions.createObjectTypeDetail(objectType)),
        createObjectTypeTranslate: (objectType, language) => dispatch(objectTypeActions.createObjectTypeTranslate(objectType, language)),
        updateObjectTypeTranslate: (objectType, language) => dispatch(objectTypeActions.updateObjectTypeTranslate(objectType, language)),
        deleteObjectTypeTranslate: (objectType, refreshParams) => dispatch(objectTypeActions.deleteObjectTypeTranslate(objectType, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ObjectTypeDetail));
